import React from 'react';

import {PriceItem} from '../priceItem/priceItem';

import s from './cartItemDetailsRow.scss';

export type PropsType = {
    title: string;
    description?: string | React.ReactElement;
    price?: number;
    finalPrice?: number;
};

/**
 * Cart Item Details Row for checkout page
 *
 * @constructor
 */
export const CartItemDetailsRow: React.FC<PropsType> = ({
    description = '',
    finalPrice = 0,
    price = 0,
    title,
}) => {
    return (
        <div className={s.row}>
            <strong className={s.title}>{title}:</strong> {description}{' '}
            {Boolean(price) && (
                <span>
                    (<PriceItem finalPrice={finalPrice} price={price} />)
                </span>
            )}
        </div>
    );
};

CartItemDetailsRow.displayName = 'CartItemDetailsRow';
